<template>
    <div :class="containerClasses">
        <svg v-if="position === 'top'" width="800" height="14" viewBox="0 0 800 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 6L555 6.00005" stroke="#F8FAFC" stroke-width="12" stroke-linecap="round" stroke-dasharray="0.01 26"/>
            <g :clip-path="`url(#${clipId})`">
                <g :filter="`url(#${filterId})`">
                    <path d="M21 6L755 6.00005" stroke="#F8FAFC" stroke-width="12" stroke-linecap="round" stroke-dasharray="0.01 26"/>
                </g>
            </g>
            <defs>
                <filter :id="filterId" x="15" y="-1" width="800" height="13.0001" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="-1"/>
                    <feGaussianBlur stdDeviation="0.5"/>
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow"/>
                </filter>
                <clipPath :id="clipId">
                    <rect width="800" height="8" fill="white" transform="translate(0 6)"/>
                </clipPath>
            </defs>
        </svg>
        <svg v-else width="800" height="13" viewBox="0 0 800 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g :filter="`url(#${filterId})`">
                <path d="M21 7L855 7.00005" stroke="#F8FAFC" stroke-width="12" stroke-linecap="round" stroke-dasharray="0.01 26" />
            </g>
            <defs>
                <filter :id="filterId" x="15" y="1" width="800" height="13" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="0.5" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0.135116 0 0 0 0 0.239299 0 0 0 0 0.358366 0 0 0 0.15 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
                </filter>
            </defs>
        </svg>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
    position: 'top' | 'bottom';
}>();

const uid = Math.random().toString(36).substring(2, 9);
const filterId = computed(() => `perforation_filter_${props.position}_${uid}`);
const clipId = computed(() => `perforation_clip_${uid}`);

const containerClasses = computed(() => ({
    'absolute left-0 max-w-full -translate-x-2 overflow-hidden': true,
    'top-0 -translate-y-1/2': props.position === 'top',
    'bottom-0 translate-y-1/2': props.position === 'bottom',
}));
</script>
